/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';
import type { MedicalSystemSubCategory } from './MedicalSystemSubCategory';
import {
    MedicalSystemSubCategoryFromJSON,
    MedicalSystemSubCategoryFromJSONTyped,
    MedicalSystemSubCategoryToJSON,
} from './MedicalSystemSubCategory';
import type { RtSystemCategory } from './RtSystemCategory';
import {
    RtSystemCategoryFromJSON,
    RtSystemCategoryFromJSONTyped,
    RtSystemCategoryToJSON,
} from './RtSystemCategory';
import type { RtSystemManufacturer } from './RtSystemManufacturer';
import {
    RtSystemManufacturerFromJSON,
    RtSystemManufacturerFromJSONTyped,
    RtSystemManufacturerToJSON,
} from './RtSystemManufacturer';

/**
 * 
 * @export
 * @interface CreateSoftwareDto
 */
export interface CreateSoftwareDto {
    /**
     * 
     * @type {string}
     * @memberof CreateSoftwareDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSoftwareDto
     */
    description?: string | null;
    /**
     * 
     * @type {RtSystemCategory}
     * @memberof CreateSoftwareDto
     */
    category: RtSystemCategory;
    /**
     * 
     * @type {RtSystemManufacturer}
     * @memberof CreateSoftwareDto
     */
    manufacturer: RtSystemManufacturer;
    /**
     * 
     * @type {string}
     * @memberof CreateSoftwareDto
     */
    model: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSoftwareDto
     */
    subModel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSoftwareDto
     */
    imageId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateSoftwareDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateSoftwareDto
     */
    isArchived?: boolean;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof CreateSoftwareDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSoftwareDto
     */
    typeSpecification?: string | null;
    /**
     * 
     * @type {MedicalSystemSubCategory}
     * @memberof CreateSoftwareDto
     */
    subCategory: MedicalSystemSubCategory;
    /**
     * 
     * @type {string}
     * @memberof CreateSoftwareDto
     */
    version?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSoftwareDto
     */
    $type?: CreateSoftwareDtoTypeEnum;
}


/**
 * @export
 */
export const CreateSoftwareDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedMedicalSystemComponentDtoDescriptionsCreateSoftwareDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.Descriptions.CreateSoftwareDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateSoftwareDtoTypeEnum = typeof CreateSoftwareDtoTypeEnum[keyof typeof CreateSoftwareDtoTypeEnum];


/**
 * Check if a given object implements the CreateSoftwareDto interface.
 */
export function instanceOfCreateSoftwareDto(value?: unknown): value is CreateSoftwareDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateSoftwareDtoTypeEnum)[0];
}

export function CreateSoftwareDtoFromJSON(json: any): CreateSoftwareDto {
    return CreateSoftwareDtoFromJSONTyped(json, false);
}

export function CreateSoftwareDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSoftwareDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'category': RtSystemCategoryFromJSON(json['category']),
        'manufacturer': RtSystemManufacturerFromJSON(json['manufacturer']),
        'model': json['model'],
        'subModel': !exists(json, 'subModel') ? undefined : json['subModel'],
        'imageId': !exists(json, 'imageId') ? undefined : json['imageId'],
        'isAvailable': !exists(json, 'isAvailable') ? undefined : json['isAvailable'],
        'isArchived': !exists(json, 'isArchived') ? undefined : json['isArchived'],
        'attachments': !exists(json, 'attachments') ? undefined : (json['attachments'] === null ? null : (json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        'typeSpecification': !exists(json, 'typeSpecification') ? undefined : json['typeSpecification'],
        'subCategory': MedicalSystemSubCategoryFromJSON(json['subCategory']),
        'version': !exists(json, 'version') ? undefined : json['version'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function CreateSoftwareDtoToJSON(value?: CreateSoftwareDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'name': value.name,
        'description': value.description,
        'category': RtSystemCategoryToJSON(value.category),
        'manufacturer': RtSystemManufacturerToJSON(value.manufacturer),
        'model': value.model,
        'subModel': value.subModel,
        'imageId': value.imageId,
        'isAvailable': value.isAvailable,
        'isArchived': value.isArchived,
        'attachments': value.attachments === undefined ? undefined : (value.attachments === null ? null : (value.attachments as Array<any>).map(FileMetaInfoDtoToJSON)),
        'typeSpecification': value.typeSpecification,
        'subCategory': MedicalSystemSubCategoryToJSON(value.subCategory),
        'version': value.version,
        '$type': value.$type,
    });
}

